module.exports = __webpack_public_path__ + "1be62af9752eaf40bca2961efca4b876.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-5.png
// module id = 2402
// module chunks = 0